/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {Devices, DownloadJob} from '@ion/core/src/types/entities';
import {ServiceError} from '@ion/core/src/types/services';
import {createDeepEqualSelector} from '../../store/selectors/SelectorUtils';

// input selectors ...
const selectJobCreate                = ({jobCreate}) => jobCreate;
const selectJobCreateShowDialog      = state => selectJobCreate(state)?.isEditing;
const selectJobCreateSelectedDevices = state => selectJobCreate(state)?.selectedDevices;
const selectJobCreateSelectedJob     = state => selectJobCreate(state)?.selectedJob;
const selectJobCreateLoading         = state => selectJobCreate(state)?.loading;
const selectJobCreateError           = state => selectJobCreate(state)?.error;
const selectJobCreateResult          = state => selectJobCreate(state)?.result;
const selectJobCreateShowAddDevices  = state => selectJobCreate(state)?.showAddDevices;

const selectJobSearchEngine  = ({jobsearchengine}) => jobsearchengine;
const selectshowAddDevices   = state => selectJobSearchEngine(state)?.showAddDevices;

// output selectors ...
export const jobCreateShowDialogSelector = createSelector(selectJobCreateShowDialog,
  (isEditing: boolean) => isEditing
);

export const jobCreateSelectedDevicesSelector = createDeepEqualSelector(selectJobCreateSelectedDevices,
  (selectedDevices: Devices) => selectedDevices
);

export const jobCreateSelectedJobSelector = createDeepEqualSelector(selectJobCreateSelectedJob,
  (selectedJob: DownloadJob) => selectedJob
);

export const jobCreateLoadingSelector = createSelector(selectJobCreateLoading,
  (loading: boolean) => loading
);

export const jobCreateErrorSelector = createDeepEqualSelector(selectJobCreateError,
  (error: ServiceError) => error
);

export const jobCreateResultSelector = createDeepEqualSelector(selectJobCreateResult,
  (result: DownloadJob) => result
);

export const jobcreateShowAddDevicesSelector = createSelector(selectJobCreateShowAddDevices,
  (showAddDevices: boolean) => showAddDevices
);

export const jobSearchEngineshowAddDevicesSelector = createSelector(selectshowAddDevices,
  (showAddDevices) => showAddDevices
);
